export default __webpack_public_path__ + "static/media/location.c97c6cac.png";